import React, { FC, useCallback } from 'react';
import { Box } from 'rebass/styled-components';
import { useDropzone } from 'react-dropzone';
import DropHint from 'components/shell/DropHint';

type Props = {
  upload(file: File): void;
  allowClick?: boolean;
  height?: string;
  disabled?: boolean;
};

const VideoDropzone: FC<Props> = ({ upload, children, allowClick = false, height = '100%', disabled = false }) => {
  const onDrop = useCallback(
    (acceptedFiles: []) => {
      acceptedFiles.forEach((file) => {
        upload(file);
      });
    },
    [upload],
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDropAccepted: onDrop,
    onDropRejected: (file) => {
      console.log(file);
    },
    accept: '.mxf,video/*,audio/*',
    multiple: true,
    noClick: !allowClick,
    disabled: disabled,
  });

  return (
    <Box
      {...getRootProps()}
      width={1 / 1}
      height={height}
      bg={'transparent'}
      sx={{
        position: 'relative',
        ':focus': { outline: 'none' },
      }}
    >
      <DropHint text="Drop videos or audio here to upload" active={isDragActive} />
      <input {...getInputProps()} />
      {children}
    </Box>
  );
};

export default VideoDropzone;
